import React, {Component} from 'react'
import Wrapper from '../common/Wrapper'
import Submenu from '../common/Submenu'
import Form from './Form.js'
import { routesUrls } from '../../settings/routes'
import history from '../../history'
import { MenuItem} from 'react-bootstrap'
import PropTypes from 'prop-types'

class CustomItems extends Component {
    static contextTypes = {formatMessage: PropTypes.any}
    render() {
      const {formatMessage} = this.context;
      return <React.Fragment>
        <MenuItem
          onClick={() => {
            history.push(routesUrls.dashboard)
          }}
        >{formatMessage('navTitleDashboard')}</MenuItem>
     </React.Fragment>
    }
  }

const Profile = () => {
    return (
        <Wrapper renderButtonNav = {false} CustomItems={CustomItems}>
            <div className="container content">
                <Submenu />
                <Form />
            </div>
        </Wrapper>
    )
}

export default Profile


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Profile/index.js